<header class="flex justify-between items-center mb-4">
  <h1 class="text-xl font-bold text-primary">{{ 'BATCH_LIST.HEADER.BATCH_LIST' | translate }}</h1>
  @if (isAgent) {
  <app-button routerLink="../create-batch" queryParamsHandling="merge" customClass="ml-2">
    + {{ 'BATCH_LIST.HEADER.CREATE_BATCH' | translate }}
  </app-button>
  }
</header>

<div class="content-card my-4">
  <div class="p-6">
    <div class="flex flex-wrap items-center justify-between gap-3" [formGroup]="filterForm">

      <app-input
        type="search"
        icon="search"
        formControlName="name"
        [placeholder]="'REQUESTLIST.FILTERS.SEARCH_BY_REQUEST_NAME' | translate"
        [reserveErrorSpace]="false"
        inputClass="!rounded-xl"
        class="flex-1 min-w-11 max-w-xl"
      ></app-input>

      <div class="flex flex-wrap items-center gap-2">

        <!-- Type d'opération -->
        <app-select
          variant="pill"
          pillClass="w-[250px]"
          [label]="'REQUESTLIST.FILTERS.OPERATION_TYPE' | translate"
          [items]="operationTypes()"
          bindLabel="name"
          bindValue="code"
          [multiple]="true"
          [emptyMessage]="'REQUESTLIST.FILTERS.NO_OPERATION_TYPE_FOUND' | translate"
          formControlName="operationTypeCode"
          (selectionChange)="checkResetIfEmpty()"
        ></app-select>

        <!-- Date -->
        <app-date-filter
          [formGroup]="filterForm"
          pillClass="w-[250px]"
          (apply)="applyFilters()"
        ></app-date-filter>
      </div>
    </div>
    @if (hasActiveFilters()) {
    <div class="pt-3 mt-3 border-t border-stone-100 flex items-center justify-between">
      <div class="flex flex-wrap items-center gap-2 text-sm">
        <span class="font-semibold text-brand-muted text-xs leading-none tracking-normal whitespace-nowrap">
          {{ 'REQUESTLIST.FILTERS.ACTIVE_FILTERS' | translate }}
        </span>

        @for (chip of getActiveFilterChips(); track chip.value) {
        <span
          class="inline-flex items-center gap-1.5 px-3 py-1 bg-surface hover:bg-primary-100 text-primary text-xs font-semibold rounded-lg transition-colors">
          <span class="font-normal text-xs leading-none tracking-normal text-stone-600">{{ chip.prefix }}</span>
          <span class="font-semibold text-xs leading-none tracking-normal text-primary">{{ chip.value
            }}</span>
          <button (click)="chip.remove()"
            class="text-stone-500 hover:text-red-600 focus:outline-none shrink-0 font-bold ml-0.5 cursor-pointer">
            ✕
          </button>
        </span>
        }

        <button (click)="resetFilters()" type="button"
          class="text-xs font-semibold text-primary hover:underline ml-2 cursor-pointer">
          {{ 'REQUESTLIST.FILTERS.BUTTONS.RESET' | translate }}
        </button>
      </div>
      <app-button size="md" (btnClick)="applyFilters()">
        <app-icon-search svgClass="w-4 h-4"></app-icon-search>
        <span>{{'REQUESTLIST.FILTERS.BUTTONS.FILTER' | translate}}</span>
      </app-button>
    </div>
    }
  </div>

  <app-data-table
  [columns]="columns"
  [data]="batchesList"
  [loading]="loading"
  [emptyTitle]="'BATCH_LIST.MESSAGES.Empty_LIST'"
  [emptyActionLabel]="isAgent ? 'BATCH_LIST.HEADER.CREATE_BATCH' : undefined"
  [emptyActionRouterLink]="isAgent ? '../create-batch' : undefined"
  [showPagination]="true"
  [currentPage]="currentPage()"
  [totalPages]="totalPages()"
  [lastPage]="lastPage()"
  [firstPage]="firstPage()"
  (pageChange)="updateCurrentPage($event)"
  (rowClick)="showDetails($event)"
>
  <!-- Colonne Date -->
  <ng-template appTableCell="createdDate" let-batch>
    <span dateTooltip [date]="batch.createdDate">
      {{ batch.createdDate | friendlyDate }}
    </span>
  </ng-template>

  <!-- Colonne Statut -->
  <ng-template appTableCell="status" let-batch>
    <app-status-badge [status]="batch.status"></app-status-badge>
  </ng-template>

  <!-- Colonne Action -->
  <ng-template appTableCell="action" let-batch>
    <app-archive-button
      [archived]="batch.archived"
      (toggle)="openArchiveModal(batch, $event)"
    ></app-archive-button>
  </ng-template>
</app-data-table>

<!-- Archive / Unarchive Confirmation Modal -->
<app-confirm-modal
  [isOpen]="!!batchToArchive"
  [title]="batchToArchive?.archived ? 'CONFIRM_MODAL.UNARCHIVE_BATCH_TITLE' : 'CONFIRM_MODAL.ARCHIVE_BATCH_TITLE'"
  [message]="batchToArchive?.archived ? 'CONFIRM_MODAL.UNARCHIVE_BATCH_MESSAGE' : 'CONFIRM_MODAL.ARCHIVE_BATCH_MESSAGE'"
  [itemName]="batchToArchive?.name"
  [confirmLabel]="batchToArchive?.archived ? 'ACTIONS.UNARCHIVE' : 'ACTIONS.ARCHIVE'"
  variant="primary"
  [loading]="isArchivingBatch"
  (confirmed)="confirmArchiveBatch()"
  (cancelled)="closeArchiveModal()"
></app-confirm-modal>
</div>